module.exports = __webpack_public_path__ + "rexiao-icon.png?a839cca329a395b2332fe5439798f073";


//////////////////
// WEBPACK FOOTER
// ./static/assets/rexiao-icon.png
// module id = 35
// module chunks = 0